import { m } from 'framer-motion';

import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';

import { varTap, varHover, transitionTap } from 'src/components/animate';

// ----------------------------------------------------------------------

export function AccountButton({ photoURL, displayName, sx, ...other }) {
  return (
    <IconButton
      component={m.button}
      whileTap={varTap(0.96)}
      whileHover={varHover(1.05)}
      transition={transitionTap()}
      aria-label="Account button"
      sx={[
        {
          p: { md: 0 },
          width: { xs: 48, md: 40 },
          height: { xs: 48, md: 40 },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      <Avatar src={photoURL} alt={displayName} sx={{ width: 32, height: 32 }} />
    </IconButton>
  );
}
